import styled from "styled-components";
import { mobileQueryMedia } from "./MediaQuery";

export const ResponsiveLayout = styled.div<{
  alignItems?: string;
  justifyContent?: string;
  flexDirection?: string;
  mobileFlexDirection?: string;
}>`
  display: flex;
  flex-direction: ${(props) => props.flexDirection ?? "row"};
  align-items: ${(props) => props.alignItems};
  justify-content: ${(props) => props.justifyContent};
  ${mobileQueryMedia} {
    flex-direction: ${(props) => props.mobileFlexDirection ?? "column"};
  }
`;
